/* tslint:disable */
/* eslint-disable */
/**
 * Sellsen API
 * Ürün Tarama ve SP-API Entegrasyonu
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the SupportRequestCreateUpdateDTO interface.
 */
export function instanceOfSupportRequestCreateUpdateDTO(value) {
    return true;
}
export function SupportRequestCreateUpdateDTOFromJSON(json) {
    return SupportRequestCreateUpdateDTOFromJSONTyped(json, false);
}
export function SupportRequestCreateUpdateDTOFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'description': json['description'] == null ? undefined : json['description'],
    };
}
export function SupportRequestCreateUpdateDTOToJSON(json) {
    return SupportRequestCreateUpdateDTOToJSONTyped(json, false);
}
export function SupportRequestCreateUpdateDTOToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'description': value['description'],
    };
}
